<div fxLayout="row wrap">
    <div fxFlex="100">
        <form class="basic-form" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
        
            <mat-card>
                <mat-card-content>
                <div fxLayout="row wrap" class="align-items-center">
                    <!-- <div fxFlex.gt-md="25" fxFlex.gt-lg="25" fxFlex="100">
                    <mat-form-field>
                        <input matInput (keyup)="applyFilter()" placeholder="Filter">
                    </mat-form-field>
                    </div> -->
                        
                        <div fxFlex.gt-sm="30" fxFlex.gt-xs="100" fxFlex="100">
                            <mat-card>
                                <mat-card-content>
                                    <!-- <mat-card-title>Date</mat-card-title> -->
                                    <!-- <mat-card-subtitle>A material 2 component for datepicker</mat-card-subtitle> -->
                                    
                                    <div  fxFlex.gt-sm="80" fxFlex="100" class="p-10">
                                      <mat-form-field style="margin-top: 15px;">
                                          <mat-select placeholder="Emp Code" formControlName="code">
                                              <!-- <mat-option value="All">All</mat-option> -->
                                              <mat-option *ngFor="let empCode of codes" [value]="empCode.code">{{ empCode.code}}-{{empCode.name}}</mat-option>
                                          </mat-select>
                                      </mat-form-field>
                                    </div>
                    
                                </mat-card-content>
                    
                            </mat-card>
                        </div>

                        <div fxFlex.gt-sm="30" fxFlex="100">
                            <button mat-raised-button color="primary" type="submit" [disabled]="!formGroup.valid">Search</button>
                        </div>
                
                    <!-- <div fxFlex.gt-md="75" class="text-right">
                    <button mat-raised-button (click)="openDialog('Add',{})" color="primary">Add Employee</button>
                    </div> -->
                </div>
                </mat-card-content>
            </mat-card>
        </form>       
    </div>
  </div>
  <div fxLayout="row wrap">
    <div fxFlex="100">
      <mat-card>
        <mat-card-content>
          <div class="table-responsive">
            <!-- <div>
              <button mat-raised-button color="warn" (click)="exportExcel()" >Export as Excel</button>
            </div> -->
            <table mat-table [dataSource]="dataSource" class="table employee-list no-wrap">
  
               
             
              <ng-container matColumnDef="EmpCode">
                <th mat-header-cell *matHeaderCellDef> Employee Code </th>
                <td mat-cell *matCellDef="let element"> {{element.code}} </td>
              </ng-container>
  
              <ng-container matColumnDef="Name">
                <th mat-header-cell *matHeaderCellDef> Name </th>
                <td mat-cell *matCellDef="let element"> {{element.emp_name}} </td>
              </ng-container>
  
  
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef> Action </th>
                <td mat-cell *matCellDef="let element" class="action-link">
                  <a (click)="openDialog(element)" class="m-r-10 cursor-pointer"><i class="fa fa-trash text-danger"></i></a>
                </td>
              </ng-container>
  
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" [attr.colspan]="displayedColumns.length" style="text-align: center;">
                  No data matching the filter.
                </td>
              </tr>
            </table>

            
            <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  